import React,{useState} from "react";
import {Modal,Form,Button} from "react-bootstrap";
import {TiTimes} from "react-icons/ti";

export default function FamilyInfoModal({show,handleClose}){

const [formData,setFormData]=useState({
name:"Hendry Peralt",
relationship:"Brother",
phone:"+1 265 6956 961",
passportExpiry:"25/05/2029"
});

const handleChange=(e)=>{
setFormData({
...formData,
[e.target.name]:e.target.value
});
};

return(
<Modal
show={show}
onHide={handleClose}
centered
size="lg"
>

<Modal.Header
style={{
padding:"18px 22px",
borderBottom:"1px solid #e5e7eb",
position:"relative"
}}
>

<Modal.Title
style={{
fontWeight:"700",
fontSize:"22px",
color:"#1e2b4d"
}}
>
Family Information
</Modal.Title>

<button
onClick={handleClose}
style={{
position:"absolute",
right:"16px",
top:"14px",
border:"none",
background:"#6b7280",
width:"28px",
height:"28px",
borderRadius:"50%",
color:"#fff"
}}
>
<TiTimes/>
</button>

</Modal.Header>


<Form>

<Modal.Body style={{padding:"18px 22px"}}>

<Form.Group className="mb-3">
<Form.Label>
Name <span style={{color:"red"}}>*</span>
</Form.Label>

<Form.Control
name="name"
value={formData.name}
onChange={handleChange}
/>
</Form.Group>


<Form.Group className="mb-3">
<Form.Label>
Relationship
</Form.Label>

<Form.Control
name="relationship"
value={formData.relationship}
onChange={handleChange}
/>
</Form.Group>


<Form.Group className="mb-3">
<Form.Label>
Phone
</Form.Label>

<Form.Control
name="phone"
value={formData.phone}
onChange={handleChange}
/>
</Form.Group>


<Form.Group className="mb-2">
<Form.Label>
Passport Expiry Date <span style={{color:"red"}}>*</span>
</Form.Label>

<Form.Control
type="date"
name="passportExpiry"
value={formData.passportExpiry}
onChange={handleChange}
/>
</Form.Group>

</Modal.Body>


<Modal.Footer
style={{
borderTop:"1px solid #e5e7eb",
padding:"14px 22px"
}}
>

<Button
variant="light"
onClick={handleClose}
style={{
border:"1px solid #d1d5db"
}}
>
Cancel
</Button>

<Button
style={{
background:"#f97316",
border:"none"
}}
>
Save
</Button>

</Modal.Footer>

</Form>

</Modal>
);
}